import { defineStore } from "pinia";

const EU = {
    weight:"kg",
    length:"cm",


}
const US = {
    weight:"pounds",
    length:"foot",


}

export const UnitSystems = defineStore('units', {
    state: () => ({EU, US}),
    getters: {

    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        getUnits(enumerable) {
            if(enumerable == 0){
                return EU;
            }
            else{
                return US;
            }
        },
    },



}) 